// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1YuSR","info":"UpdateTermsInfo_info__1PSCN"};